<template>
  <div class="flex-none flex justify-between p-2">
    <div class="flex flex-1">
      <slot />
    </div>
    <div class="ml-2 flex">
      <BaseButton primary :disabled="disabled" @click="monthlyView"> Monthly </BaseButton>
      <div class="glue-h">
        <BaseButton primary class="ml-2" :disabled="disabled" @click="prevWeek">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            class="fill-current"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M14.71 6.70999C14.6175 6.61728 14.5076 6.54373 14.3866 6.49355C14.2657
              6.44337 14.136 6.41754 14.005 6.41754C13.874 6.41754 13.7444 6.44337
              13.6234 6.49355C13.5024 6.54373 13.3925 6.61728 13.3 6.70999L8.71
              11.3C8.6173 11.3925 8.54375 11.5024 8.49357 11.6234C8.44339 11.7443
              8.41756 11.874 8.41756 12.005C8.41756 12.136 8.44339 12.2656 8.49357
              12.3866C8.54375 12.5076 8.6173 12.6175 8.71 12.71L13.3 17.3C13.3926
              17.3926 13.5025 17.466 13.6235 17.5161C13.7444 17.5662 13.8741 17.592
              14.005 17.592C14.1359 17.592 14.2656 17.5662 14.3865 17.5161C14.5075
              17.466 14.6174 17.3926 14.71 17.3C14.8026 17.2074 14.876 17.0975 14.9261
              16.9765C14.9762 16.8556 15.002 16.7259 15.002 16.595C15.002 16.4641
              14.9762 16.3344 14.9261 16.2134C14.876 16.0925 14.8026 15.9826 14.71
              15.89L10.83 12L14.71 8.11999C15.1 7.72999 15.09 7.08999 14.71 6.70999V6.70999Z"
            />
          </svg>
        </BaseButton>
        <BaseButton primary class="ml-2" :disabled="disabled" @click="today"> Today </BaseButton>
        <BaseButton primary class="ml-2 flex" :disabled="disabled" @click="nextWeek">
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            class="fill-current"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M9.29 6.70999C9.1973 6.80251 9.12375 6.91239 9.07357 7.03337C9.02339
              7.15434 8.99756 7.28402 8.99756 7.41499C8.99756 7.54596 9.02339 7.67564
              9.07357 7.79662C9.12375 7.91759 9.1973 8.02748 9.29 8.11999L13.17 12L9.29
              15.88C9.19742 15.9726 9.12398 16.0825 9.07388 16.2034C9.02377 16.3244
              8.99798 16.4541 8.99798 16.585C8.99798 16.7159 9.02377 16.8456 9.07388
              16.9665C9.12398 17.0875 9.19742 17.1974 9.29 17.29C9.38258 17.3826
              9.4925 17.456 9.61346 17.5061C9.73442 17.5562 9.86407 17.582 9.995
              17.582C10.1259 17.582 10.2556 17.5562 10.3765 17.5061C10.4975 17.456
              10.6074 17.3826 10.7 17.29L15.29 12.7C15.3827 12.6075 15.4563 12.4976
              15.5064 12.3766C15.5566 12.2556 15.5824 12.126 15.5824 11.995C15.5824
              11.864 15.5566 11.7343 15.5064 11.6134C15.4563 11.4924 15.3827 11.3825
              15.29 11.29L10.7 6.69999C10.32 6.31999 9.68 6.31999 9.29 6.70999Z"
            />
          </svg>
        </BaseButton>
      </div>
      <!-- <button
        class="btn btn-brand"
        :disabled="disabled"
        @click="monthlyView"
      >
        Monthly
      </button>
      <button
        class="btn btn-brand ml-2"
        :disabled="disabled"
        @click="prevWeek"
      >
        Prev Week
      </button>
      <button
        class="btn btn-brand ml-2"
        :disabled="disabled"
        @click="today"
      >
        Today
      </button>
      <button
        class="btn btn-brand ml-2"
        :disabled="disabled"
        @click="nextWeek"
      >
        Next Week
      </button> -->
    </div>
  </div>
</template>

<script>
export default {
  name: 'Actions',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    monthlyView() {
      this.$emit('set-monthly-view');
    },
    prevWeek() {
      this.$emit('prev-week');
    },
    nextWeek() {
      this.$emit('next-week');
    },
    today() {
      this.$emit('today');
    },
  },
};
</script>
